import React, { Component } from "react"
import { Notifier } from "@airbrake/browser"
import {
  AIRBRAKE_API_KEY,
  AIRBRAKE_PROJECT_ID,
  BUILD_ENV,
  BLACKLISTED_ERRORS
} from "../../../constants"
import HomeSearchBar from "../../marketing/homepage/homeSearchBar.js"
import { Columns } from "components/elements"
import "./notfound.sass"
export default class MyErrorBoundary extends Component {
  state = {
    error: null
  }

  airbrake = new Notifier({
    projectId: AIRBRAKE_PROJECT_ID,
    projectKey: AIRBRAKE_API_KEY
  })

  componentWillUnmount() {}
  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI.

    return { error: error }
  }

  componentDidCatch(error, info) {
    // Log the error to an error reporting service
    if (!BLACKLISTED_ERRORS.includes(error.message)) {
      this.airbrake.notify({
        error: error,
        environment: { env: BUILD_ENV },
        params: { info: info }
      })
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="not-found-wrap">
          <div className="not-found-wrap-inner">
            <Columns className="is-centered">
              <Columns.Column size={6}>
                <h1 className="has-text-centered">
                  ERROR <span>We can't find what you're looking for.</span>
                </h1>

                <p className="has-text-centered">Search for a Motorcycle</p>

                <HomeSearchBar />

                <p className="has-text-centered mb-2">-- OR --</p>

                <p className="has-text-centered">
                  <a
                    className="button is-large is-primary"
                    href="/list-your-motorcycle"
                  >
                    List Your Motorcycle!
                  </a>
                </p>
              </Columns.Column>
            </Columns>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

/*

Below is some left over code from whenn this was part of api.js before creating the proper error handler.

const airbrake = new AirbrakeClient({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_API_KEY,
  keysBlacklist: [
    "password", // exact match
    "ssn", // regexp match
    "owner_ssn" // regexp match
  ]
});

airbrake.addFilter(function(notice) {
  if (BUILD_ENV !== "production") {
    //Ignore errors from admin sessions.
    return notice;
  }
  return notice;
});

const airBrakeOnAPICall = (
  apiType,
  error,
  data,
  componentDesc,
  processName,
  urlSuffix
) => {
  //here we build the error string

  let airBrakeInfo = {
    error: error,
    environment: { env: BUILD_ENV },

    params: {
      data_sent: data,
      api_type: apiType,
      react_component: componentDesc,
      api_call: processName,
      api_url: urlSuffix
    }
  };

  if (error.response) {
    airBrakeInfo.params.error_status = error.response.status;
    airBrakeInfo.params.error_data = error.response.data;
    airBrakeInfo.params.error_headers = error.response.headers;

    if (error.response.data.error_messages) {
      airBrakeInfo.error =
        error.response.status +
        " - " +
        error.response.data.error_messages[0] +
        " - " +
        componentDesc;
    }
  } else if (error.request) {
    airBrakeInfo.params.error_request = error.request;
  } else {
    airBrakeInfo.params.error_data = error.message;
  }

  //console.log(airBrakeInfo)
  //airbrake.notify(airBrakeInfo);
};

*/
